import { convertToMapById } from "helpers/convertToMap";
import { convertToObjById } from "helpers/convertToObject";
import { formatCustomDate } from "helpers/dateTools";
import { comoDataTypes } from "./comoDataTypes";

const {
  SET_COMO_DATA_FILTERS,
  COMO_DATA_SELECTED,
  GET_COMO_DATA,
  CREATE_COMO_DATA,
  MOD_COMO_DATA,
  DELETE_COMO_DATA,
  RESET_COMO_DATA_SELECTED,
  ADD_COMO_DATA_MODE,
  EDIT_COMO_DATA_MODE,
  CHECK_ADD_COMO_DATA_MODE_PERMIT,
  DELETE_COMO_DATA_MODE,
  CLEAR_COMO_DATA,
  SET_CONFIG_FILTER_COMO_DATA,
  SET_CONFIG_PAGE_COMO_DATA,
  SET_CONFIG_PAGE_SIZE_COMO_DATA,
  SET_CONFIG_SORTED_COMO_DATA,
  CLEAN_COMO_DATA,
} = comoDataTypes

const INITIAL_STATE = {
  comoDataSelected: null,
  newComoDataId: null,
  comoDataObj: {},
  comoDataArr: [],
  addComoData: true,
  addMode: false,
  deleteMode: false,
  station: {},
  config: {
      page: 0,
      pageSize: 20,
      filtered: [],
      sorted: []
  },
}

export const comoDataReducer = (state = INITIAL_STATE, {type, payload}) => {

  switch (type) {
    
    case SET_COMO_DATA_FILTERS:
      return {
          ...state,
          [payload.key]: payload.data,
      };

    case ADD_COMO_DATA_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case EDIT_COMO_DATA_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case DELETE_COMO_DATA_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }
    
    case CHECK_ADD_COMO_DATA_MODE_PERMIT:
      return {
        ...state,
        addComoData: payload,
      }
    case CLEAN_COMO_DATA:
      return {
        ...state,
        comoDataArr: [],
        comoDataObj: {},
      }

    case GET_COMO_DATA:
      const filteredComoData = payload.map(comoData => {
        return {
          ...comoData,
          contract: comoData.contract ? {
            ...comoData.contract,
            name: comoData.contract.filename
          } : null,
          evidence: comoData.evidence.map(file => ({...file, name: file.filename})),
          startDate: formatCustomDate(comoData.startDate, '-'),
          endDate: formatCustomDate(comoData.endDate, '-')
        }
      });
      const listComoData = convertToObjById(filteredComoData);
      return {
        ...state,
        comoDataObj: listComoData,
        comoDataArr: filteredComoData,
      }

    case COMO_DATA_SELECTED:
      return {
        ...state,
        comoDataSelected: payload && state.comoDataObj[payload]
      }

    case RESET_COMO_DATA_SELECTED:
      return {
        ...state,
        comoDataSelected: null,
        newComoDataId: null
      }

    case CREATE_COMO_DATA:
      const addingComoData = [{
        ...payload,
        contract: payload.contract ? {
          ...payload.contract,
          name: payload.contract.filename
        } : null,
        evidence: payload.evidence.map(file => ({...file, name: file.filename})),
        startDate: formatCustomDate(payload.startDate, '-'),
        endDate: formatCustomDate(payload.endDate, '-')
      }, ...state.comoDataArr]
      const newComoData = convertToObjById(addingComoData)
      return {
        ...state,
        comoDataObj: newComoData,
        comoDataArr: addingComoData,
      }

    case MOD_COMO_DATA:
      const editedComoData = {
        ...state.comoDataObj,
        [payload.id]: {
          ...state.comoDataObj[payload.id],
          ...payload,
          contract: payload.contract ? {
            ...payload.contract,
            name: payload.contract.filename
          } : null,
          evidence: payload.evidence.map(file => ({...file, name: file.filename})),
          startDate: formatCustomDate(payload.startDate, '-'),
          endDate: formatCustomDate(payload.endDate, '-')
        },
      }
      return {
        ...state,
        comoDataObj: editedComoData,
        comoDataArr: convertToMapById(editedComoData),
        comoDataSelected: state.comoDataSelected?.id === payload.id
          ? editedComoData[payload.id]
          : state.comoDataSelected
      }

    case DELETE_COMO_DATA:
      const dataArray = state.comoDataArr.filter(comoData => comoData.id !== payload)
      return {
        ...state,
        comoDataObj: convertToObjById(dataArray),
        comoDataArr: dataArray
      }

    case CLEAR_COMO_DATA:
      return {
          ...state,
          ...INITIAL_STATE,
      };

    case SET_CONFIG_FILTER_COMO_DATA:
      return {
          ...state,
          config: {
              ...state.config,
              filtered: payload,
              page: 0,
          },
      };

    case SET_CONFIG_PAGE_COMO_DATA:
        return {
            ...state,
            config: {
                ...state.config,
                page: payload,
            },
        };

    case SET_CONFIG_PAGE_SIZE_COMO_DATA:
        return {
            ...state,
            config: {
                ...state.config,
                pageSize: payload,
                page: 0,
            },
        };

    case SET_CONFIG_SORTED_COMO_DATA:
        return {
            ...state,
            config: {
                ...state.config,
                sorted: payload,
                page: 0,
            }
        }
  
    default :
      return state
  }
}